import { useEffect, useState } from 'react';
import { resolveBrandPlaceholder, resolveBrandPlaceholderFallback } from '../lib/brand-assets';
import { getCDNImage } from '../lib/cdnImage';
import { getSiteProfile } from '../lib/site-profile';

/**
 * Brand-safe image with instant onError fallback (masks WAF/CDN dropouts).
 * Relative Supabase storage keys resolve via getCDNImage.
 */
export default function BrandImage({
  src,
  alt = '',
  className = '',
  siteRole,
  showVerifiedBadge = false,
  verified = false,
  ...props
}) {
  const site = siteRole || getSiteProfile().id;
  const primaryFallback = resolveBrandPlaceholder(site);
  const secondaryFallback = resolveBrandPlaceholderFallback(site);
  const resolvedSrc = getCDNImage(src, primaryFallback);
  const [currentSrc, setCurrentSrc] = useState(resolvedSrc || primaryFallback);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setCurrentSrc(resolvedSrc || primaryFallback);
    setErrored(false);
  }, [resolvedSrc, primaryFallback]);

  return (
    <div className={`relative overflow-hidden ${className}`.trim()}>
      <img
        {...props}
        src={currentSrc || primaryFallback}
        alt={alt}
        className="h-full w-full object-cover"
        loading="lazy"
        onError={() => {
          if (!errored) {
            setErrored(true);
            setCurrentSrc(
              currentSrc === primaryFallback ? secondaryFallback : primaryFallback
            );
          }
        }}
      />
      {showVerifiedBadge && verified && !errored ? (
        <span className="absolute right-2 top-2 rounded-full bg-emerald-500/90 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
          Verified
        </span>
      ) : null}
    </div>
  );
}
